function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("g", null);

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  version: 1.1,
  id: "Capa_1",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  width: 24,
  height: 24,
  viewBox: "0 0 204.692 204.692",
  style: {
    "enableBackground": "new 0 0 204.692 204.692"
  },
  xmlSpace: "preserve"
}, props), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#010002"
  },
  d: "M167.998,49.589l8.274-8.274l3.661,3.661l4.649-4.645l-12.376-12.376l-4.649,4.649l4.066,4.062 l-8.36,8.36c-16.194-14.48-37.535-23.309-60.912-23.309c-50.455,0-91.49,41.042-91.49,91.486c0,50.447,41.035,91.49,91.49,91.49 c50.433,0,91.479-41.046,91.479-91.49C193.831,88.505,183.967,66.066,167.998,49.589z M106.102,198.029v-16.201h-7.516v16.201 c-43.995-1.918-79.393-37.471-81.082-81.526h13.303v-6.578H17.504c1.696-44.213,37.342-79.855,81.562-81.551v14.14h6.567v-14.14 c44.21,1.696,79.855,37.338,81.548,81.551h-12.354v6.578h12.354C185.485,160.558,150.097,196.11,106.102,198.029z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#010002"
  },
  d: "M106.102,102.538V52.695c0-2.133-1.374-3.851-3.071-3.851c-1.707,0-3.078,1.714-3.078,3.851 v49.413c-5.125,1.102-8.976,5.655-8.976,11.098c0,5.458,3.851,10.01,8.976,11.109v4.95c0,2.137,1.374,3.858,3.078,3.858 c1.696,0,3.071-1.721,3.071-3.858v-5.379c4.413-1.56,7.598-5.73,7.598-10.679C113.7,108.257,110.515,104.087,106.102,102.538z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 99.066,
  y: 0,
  style: {
    "fill": "#010002"
  },
  width: 6.567,
  height: 17.501
})))), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15);

export default __webpack_public_path__ + "static/media/icon.9b4ee226.svg";
export { SvgComponent as ReactComponent };